/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { uiTypes } from '@opengeoweb/store';
import { PublicWarningStatus } from './types';

export const publicWarningDialogType = uiTypes.DialogTypes.PublicWarnings;

// A warning that is no longer active: expired, withdrawn or replaced by an
// update. These are shown greyed out in the Expired section.
export const isEndedStatus = (status?: PublicWarningStatus): boolean =>
  status === PublicWarningStatus.EXPIRED ||
  status === PublicWarningStatus.WITHDRAWN ||
  status === PublicWarningStatus.UPDATED;

export const warningEventDialogType = uiTypes.DialogTypes.WarningsEvent;
export const warningEventsSummaryDialogType =
  uiTypes.DialogTypes.WarningsEventSummary;
